import { FavouriteModelComponent } from '../favourite/common/favourite-model-component';
import { FavouriteDataOptions } from '../favourite/common/favourite-data-options';
import { ErrorHandler } from '../favourite/common/error-handler';
import { LayoutConfig } from '../favourite/common/layout-config';
import { FavouriteLayoutAttributes } from '../types';
import { ColumnType } from '../constants';
import { textMappings, tooltipSection } from './constants';
import { FavouriteDataModel, AggregationType } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { CaseViewCallback, DrillDownCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { FavouriteDataAdapter } from 'app/components/favourite-layout/favourite/common/favourite-data-adapter';

export class TableFavouriteModelComponent extends FavouriteModelComponent {

  private dataOptions: FavouriteDataOptions;
  public dataAdapter: FavouriteDataAdapter = new FavouriteDataAdapter(this.config, this.dataModel, this.intl, this.translation);

  constructor(layoutAttributes: FavouriteLayoutAttributes, intl: any, translation: any,
    errorHandler: ErrorHandler, drillDown: DrillDownCallback, caseview: CaseViewCallback) {

    const config = new LayoutConfig(layoutAttributes);

    super(config, intl, translation, errorHandler, drillDown, caseview);

    this.dataOptions = new FavouriteDataOptions(config, this.dataAdapter);
  }

  public receiveData(dataModel: FavouriteDataModel) {
    super.receiveData(dataModel);

    this.dataOptions = new FavouriteDataOptions(this.config, this.dataAdapter);
  }

  public format(columnIndex: number, value: any) {
    if (value !== null && value !== undefined && value.value !== undefined) {
      if (this.dataModel.columns[columnIndex].columnType === ColumnType.aggregation && this.dataModel.report === 10 && value.noExp) {
        return this.config.text(textMappings.noExposureValue);
      }
      if (this.dataModel.columns[columnIndex].columnType === ColumnType.target && value.noTar) {
        return this.config.text(textMappings.noTargetValue);
      }
      return this.dataAdapter.format(columnIndex, value.value);
    }
    return this.dataAdapter.format(columnIndex, value);
  }

  /**
   * Returns footer label and value
   *
   * @param aggregationType 
   */
  public getFooterColumnTextAndValue(aggregationType: AggregationType): {
    label: string;
    value: string;
  } {

    const { aggrColIndex, columnExtremes } = this.dataAdapter;
    switch (aggregationType) {

      case AggregationType.Minimum:
      case AggregationType.DaysSinceLast:
        return {
          label: this.config.text(textMappings.minimum),
          value: this.format(aggrColIndex, columnExtremes[aggrColIndex].min)
        };

      case AggregationType.Maximum:
      case AggregationType.DaysSinceFirst:
        return {
          label: this.config.text(textMappings.maximum),
          value: this.format(aggrColIndex, columnExtremes[aggrColIndex].max)
        };

      default:
        return {
          label: this.config.text(textMappings.total),
          value: this.format(aggrColIndex, columnExtremes[aggrColIndex].sum)
        };
    }
  }

  /**
   * Returns header title
   *
   * @param colIndex column number in table
   */
  public getHeaderTitle(colIndex: number): string {
    return this.dataOptions.getColumnTitle(colIndex);
  }

  /**
   * Returns cell tooltip
   *
   * @param colIndex column number in table
   */
  public getTooltip(colIndex: number): string {
    return this.dataOptions.getColumnTitle(colIndex, tooltipSection);
  }
}
